<div class="match-container">
  <div class="match-flex-grid">
    <div class="match-flex-item" style="text-align: center" *ngFor="let finger of fingers">
      <img src="{{finger}}" alt="" class="match-img" (click)="showLarge(finger)">
    </div>
  </div>
</div>
